import { IdogcamCamera, IdogcamCameraChanges, IdogcamLocation } from './IdogcamModel';

export type IdogcamCameraFormField = 'accessType' | 'addressId' | 'roomId' | 'roomUnitId';

export type IdogcamCameraFormErrors = Partial<Record<IdogcamCameraFormField, string>>;

// Pre-fills the location for cameras never configured: most marketplaces have a single
// address, so staff should not have to pick it by hand.
export const createCameraForm = (camera: IdogcamCamera, locations: Array<IdogcamLocation>): IdogcamCameraChanges => {
    const defaultLocation = locations.find(location => location.main) ?? (locations.length === 1 ? locations[0] : null);

    return {
        active: camera.active,
        accessType: camera.accessType,
        addressId: camera.addressId ?? defaultLocation?.id ?? null,
        roomId: camera.roomId,
        roomUnitId: camera.roomUnitId
    };
};

// Mirrors IdogcamCamera#validate_access_configuration in the backend.
export const validateCameraForm = (form: IdogcamCameraChanges): IdogcamCameraFormErrors => {
    const errors: IdogcamCameraFormErrors = {};

    if (form.active && !form.accessType) {
        errors.accessType = 'Select a camera type to activate this camera';
    }

    if (form.accessType && !form.addressId) {
        errors.addressId = 'Location is required';
    }

    if (form.accessType === 'private') {
        if (!form.roomId) errors.roomId = 'Room is required';
        if (!form.roomUnitId) errors.roomUnitId = 'Unit is required';
    }

    return errors;
};

export const isCameraFormDirty = (form: IdogcamCameraChanges, initial: IdogcamCameraChanges): boolean =>
    form.active !== initial.active ||
    form.accessType !== initial.accessType ||
    form.addressId !== initial.addressId ||
    (form.accessType === 'private' && (form.roomId !== initial.roomId || form.roomUnitId !== initial.roomUnitId));
